module.exports = __webpack_public_path__ + "img/intercomdescribe3.0352e35d.png";